import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { pageNameToRelativePath } from "src/app/_helpers/utility/page-name-to-relative-path";
import { GeographicAreasService } from "src/app/_services/shared/geographic-areas/geographic-areas.service";
import { AuthenticationService } from "src/app/_services/user/authentication/authentication.service";
import { DBkeys } from "src/app/_services/user/authentication/dbkeys.service";
import { LocalStoreManagerService } from "src/app/_services/user/authentication/local-store-manager.service";
import { SystemPreferencesService } from "src/app/_services/user/system-preferences.service";
import { UserDetailsService } from "src/app/_services/user/user-details.service";

@Component({
    selector: "wfdss-sso-response-handler",
    templateUrl: "./sso-response-handler.component.html",
    styleUrls: ["./sso-response-handler.component.scss"],
    standalone: false
})
export class SsoResponseHandlerComponent {
  routeSubscription: Subscription;

  message;

  napRedirectUrl;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: LocalStoreManagerService,
    private authService: AuthenticationService,
    private systemPreferencesService: SystemPreferencesService
  ) {
    this.routeSubscription = this.route.queryParams.subscribe((params) => {
      const state = this.localStorage.getData(DBkeys.SSO_STATE);

      if (params.state !== state) {
        this.message =
          "Authentication failed. Returned 'State' parameter doesn't match initiated value.";
      } else {
        this.message =
          "Authentication success. Subsequent login steps in progress.";
        authService
          .exchangeAuthCodeForIdToken(
            params.code,
            window.localStorage.getItem("requestedRole")
          )
          .subscribe(
            async (responsePromise) => {
              const response = await responsePromise;

              console.debug(`User ${response.user?.username} logged in`);

              this.systemPreferencesService
                .getSystemPreferencesForUser(response.user?.userId)
                .toPromise()
                .then((prefs) => {
                  this.router.navigateByUrl(
                    pageNameToRelativePath[prefs.postLoginRedirectPage] ?? "/"
                  );
                });
            },
            (error) => {
              console.debug(error, "Error authenticating with iNap");
              console.debug(error.headers);

              if (error.status === 403) {
                this.napRedirectUrl = error.headers.get("location");
              } else if (error.status === 400 || error.status === 500) {
                this.message = "Error authenticating with iNap. If this error persists, please contact the system administrator or WFDSS Support Staff."
              }
            }
          );
      }
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
}
